/* eslint-disable no-undef */
import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import Spinner from "./Spinner";
import { payloadData } from "../info/info.js";
import "../index";
import "./Spinner";
import { Turnstile } from "@marsidev/react-turnstile";

const Formulario = (props) => {
  const [request, setRequest] = useState({
    url: "https://des.payku.cl",
    publico: "",
    privado: "",
    id: "",
    endpoint: "/api/transaction/",
    method: "get",
  });
  const [result, setResult] = useState("");
  const [firma, setFirma] = useState("");
  const [errors, setErrors] = useState("");
  const [errorsEndpoint, setErrorsEndpoint] = useState("");
  const [errorPrivado, setErrorPrivado] = useState("");
  const [status, setStatus] = useState("");
  const [responsiveTurnstile, setResponsiveTurnstile] = useState(
    window.innerWidth < 991
      ? {
          size: "compact",
          theme: "light",
        }
      : {
          size: "normal",
          theme: "light",
        }
  );
  // const [openModalFailedCaptcha, setopenModalfailedCaptcha] = useState(false);
  // const [captchaValidoButton, setCaptchaValidoButton] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [counter, setCounter] = useState(0);
  const { suggestions } = props;

  const testing = window.location.search;
  const urlParams = new URLSearchParams(testing);
  const validate = urlParams.get("valid");
  const dateCopy = new Date();
  const yearCopy = dateCopy.getFullYear();

  const handleChange = (e) => {
    setRequest({
      ...request,
      [e.target.name]: e.target.value,
    });
  };

  // useEffect(() => {
  //   var captchaValido = document.querySelector(".geetest_captcha");
  //   if (captchaValido === null) {
  //     var captchaId = process.env.REACT_APP_CATCHAID;
  //     var product = "float";
  //     initGeetest4(
  //       {
  //         captchaId: captchaId,
  //         product: product,
  //         https: true,
  //       },
  //       function (gt) {
  //         window.gt = gt;
  //         gt.appendTo("#captcha").onSuccess(function (e) {
  //           var result = gt.getValidate();
  //           setCaptchaValidoButton(result);
  //         });
  //       }
  //     );
  //   }
  // }, []);
  // useEffect(() => {
  //   function handleResize() {
  //     // console.log("resized to: ", window.innerWidth,);
  //     if (window.innerWidth < 413) {
  //       setResponsiveTurnstile({
  //         size: "compact",
  //         theme: "light",
  //       });
  //     } else {
  //       setResponsiveTurnstile({
  //         size: "normal",
  //         theme: "light",
  //       });
  //     }
  //   }

  //   window.addEventListener("resize", handleResize);
  // }, [responsiveTurnstile]);

  useEffect(() => {
    if (status === "error") {
      setopenModalfailedCaptcha(true);
    }
  }, [status]);

  useEffect(() => {
    if (result) {
      setCargando(false);
    }
  }, [result]);

  useEffect(() => {
    if (request.method === "post" || request.method === "put") {
      setRequest({
        ...request,
        codigo: payloadData[request.endpoint]?.resultPL,
      });
    }
    if (
      request.method === "get" ||
      request.method === "delete" ||
      request.method === "post" ||
      request.method === "put"
    ) {
      setResult("");
    }
  }, [request.method, request.endpoint]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCounter(counter + 1);
    // if (counter === 10) {
      // gt.reset();
    // }

    let errores = "";
    // let dataParse = "";
    let dataExample =
      '{"email": "support@youwebsite.cl","name": "Joe Doe","rut": "11111111","phone": "923122312","address":"Moneda101","country": "Chile","region": "Metropolitana","city": "Santiago","postal_code": "850000"}';
    let exampleJson = JSON.parse(dataExample);

    setErrors("");
    setErrorPrivado("");
    setFirma("");
    setErrorsEndpoint("");

    if (!`${request.publico}`.trim()) {
      errores = "You must enter a valid Public token";
      setErrors(errores);
    } else if (`${request.publico}`.length !== 32) {
      errores = "Public Token must contain 32 characters";
      setErrors(errores);
    } else if (!`${request.publico}`.match(/^[a-zA-Z0-9]+$/)) {
      errores = "Public Token must not contain special characters";
      setErrors(errores);
    }
    if (`${request.endpoint}` === "") {
      errores = "You must enter a valid EndPoint";
      setErrorsEndpoint(errores);
    }

    if (`${request.endpoint}` !== "/api/transaction/") {
      if (!`${request.privado}`.trim()) {
        errores = "You must enter a valid Private token";
        setErrorPrivado(errores);
      } else if (`${request.privado}`.length !== 32) {
        errores = "Private Token must contain 32 characters";
        setErrorPrivado(errores);
      } else if (!`${request.privado}`.match(/^[a-zA-Z0-9]+$/)) {
        errores = "Private Token must not contain special characters";
        setErrorPrivado(errores);
      }
    }
    if (request.method === "post" || request.method === "put") {
      try {
        // dataParse = JSON.parse(request.codigo);
      } catch (error) {
        errores = "errorParse";
        setResult(
          `There has been an error in the format of the data sent, please check that it is written as follows:  \n ${JSON.stringify(
            exampleJson,
            null,
            2
          )} \n and rectify that the last line of the values does NOT have a comma(,)`
        );
      }
    }

    if (errores === "") {
      apiRequest(
        `${request.method}`,
        `${request.endpoint}`,
        `${request.codigo}`,
        `${request.publico}`,
        `${request.privado}`,
        `${request.id}`
      )
        .then((axiosRes) => setResult(JSON.stringify(axiosRes.data, null, 2)))
        .catch((res) => setResult(JSON.stringify(res.response, null, 2)));

      // setCaptchaValidoButton(true);
      // if (counter === 10) {
      //   setCaptchaValidoButton(false);
      // }
    } else {
    }
  };

  const createSign = (e) => {
    e.preventDefault();
    setCounter(counter + 1);
    // if (counter === 10) {
    //   gt.reset();
    // }

    let errores = "";
    // let dataParse = "";
    let sign;
    let dataExample =
      '{"email": "support@youwebsite.cl","name": "Joe Doe","rut": "11111111","phone": "923122312","address":"Moneda101","country": "Chile","region": "Metropolitana","city": "Santiago","postal_code": "850000"}';
    let exampleJson = JSON.parse(dataExample);

    setErrors("");
    setErrorPrivado("");
    setFirma("");
    setErrorsEndpoint("");

    if (!`${request.publico}`.trim()) {
      errores = "You must enter a valid Public token";
      setErrors(errores);
    } else if (`${request.publico}`.length !== 32) {
      errores = "Public Token must contain 32 characters";
      setErrors(errores);
    } else if (!`${request.publico}`.match(/^[a-zA-Z0-9]+$/)) {
      errores = "Public Token must not contain special characters";
      setErrors(errores);
    }
    if (`${request.endpoint}` === "") {
      errores = "You must enter a valid EndPoint";
      setErrorsEndpoint(errores);
    }

    if (`${request.endpoint}` !== "/api/transaction/") {
      if (!`${request.privado}`.trim()) {
        errores = "You must enter a valid Private token";
        setErrorPrivado(errores);
      } else if (`${request.privado}`.length !== 32) {
        errores = "Private Token must contain 32 characters";
        setErrorPrivado(errores);
      } else if (!`${request.privado}`.match(/^[a-zA-Z0-9]+$/)) {
        errores = "Private Token must not contain special characters";
        setErrorPrivado(errores);
      }
    }
    if (request.method === "post" || request.method === "put") {
      try {
        // dataParse = JSON.parse(request.codigo);
      } catch (error) {
        errores = "errorParse";
        setResult(
          `There has been an error in the format of the data sent, please check that it is written as follows:  \n ${JSON.stringify(
            exampleJson,
            null,
            2
          )} \n and rectify that the last line of the values does NOT have a comma(,)`
        );
      }
    }

    if (errores === "") {
      ////////////////////////////////////////////////////////////////////////////////////////////

      let dataExample =
      '{"email": "support@youwebsite.cl","name": "Joe Doe","rut": "11111111","phone": "923122312","address":"Moneda101","country": "Chile","region": "Metropolitana","city": "Santiago","postal_code": "850000"}';

      let exampleJson = JSON.parse(dataExample);
      let sendDataCopy = "";

      if (request.method === "post" || request.method === "put") {
        try {
          sendDataCopy = request.codigo;
          sendDataCopy = JSON.parse(sendDataCopy);
        } catch (error) {
          setResult(
            `There has been an error in the format of the data sent, please check that it is written as follows:  \n ${JSON.stringify(
              exampleJson,
              null,
              2
            )} \n and rectify that the last line of the values does NOT have a comma(,)`
          );
        }
      }

      if (`${request.endpoint}` !== "/api/transaction/") {
        const requestPath = encodeURIComponent(
          `${request.endpoint}${request.id}`
        );
        const orderedData = {};
        Object.keys(sendDataCopy)
          .sort()
          .forEach(function (key) {
            orderedData[key] = sendDataCopy[key];

            if (typeof orderedData[key] === "object") {
              delete orderedData[key];
            }
          });

        const arrayConcat = new URLSearchParams(orderedData).toString();
        const concat = requestPath + "&" + arrayConcat;
        sign = CryptoJS.HmacSHA256(concat, `${request.privado}`).toString();
        setFirma(sign);
        }




    } else {
    }
  };

  const apiRequest = (
    method,
    path,
    sendData,
    publicToken,
    privateToken = "",
    id = "",
    sign = ""
  ) => {
    let dataExample =
      '{"email": "support@youwebsite.cl","name": "Joe Doe","rut": "11111111","phone": "923122312","address":"Moneda101","country": "Chile","region": "Metropolitana","city": "Santiago","postal_code": "850000"}';

    let exampleJson = JSON.parse(dataExample);
    let sendDataCopy = "";

    if (method === "post" || method === "put") {
      try {
        sendDataCopy = sendData;
        sendDataCopy = JSON.parse(sendDataCopy);
      } catch (error) {
        setResult(
          `There has been an error in the format of the data sent, please check that it is written as follows:  \n ${JSON.stringify(
            exampleJson,
            null,
            2
          )} \n and rectify that the last line of the values does NOT have a comma(,)`
        );
      }
    }

    if (`${request.endpoint}` !== "/api/transaction/") {
      const requestPath = encodeURIComponent(
        `${request.endpoint}${request.id}`
      );
      const orderedData = {};
      Object.keys(sendDataCopy)
        .sort()
        .forEach(function (key) {
          orderedData[key] = sendDataCopy[key];

          if (typeof orderedData[key] === "object") {
            delete orderedData[key];
          }
        });

      const arrayConcat = new URLSearchParams(orderedData).toString();
      const concat = requestPath + "&" + arrayConcat;
      sign = CryptoJS.HmacSHA256(concat, `${privateToken}`).toString();
      setFirma(sign);
    }

    setCargando(true);

      return axios({
        method: `${method}`,
        url: `${request.url}${path}${id}`,
        data: sendDataCopy,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${publicToken}`,
          Sign: sign,
        },
      });
  };

  return (
    <Fragment>
      <div className="container">
        <div className="card card-styles">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <form className="form">
                <div className="title text-color d-flex justify-content-center mb-5">
                  <img
                    src="https://storage.googleapis.com/storage-payku-prd/public/img/payku2020_2.svg"
                    // width="156"
                    height="110"
                    alt="payku"
                  />
                </div>

                <div className="row">
                  <div className="col-xl-4">
                    <div className="form-group">
                      <label>Platform</label>
                      <select
                        onChange={handleChange}
                        name="url"
                        className="form-control form-control-lg mb-5 mt-2 text-color"
                      >
                        <option value="https://des.payku.cl">
                          Development
                        </option>
                        <option value="https://app.payku.cl">Production</option>
                        {process.env.REACT_APP_INTRAVALIDATE === validate && (
                          <option value="https://devqa.payku.cl">QA</option>
                        )}
                        {process.env.REACT_APP_INTRAVALIDATE === validate && (
                          <option value="http://127.0.0.2">Localhost</option>
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-xl-4">
                    <div className="form-group">
                      <label>Method</label>
                      <select
                        onChange={handleChange}
                        name="method"
                        className="form-control form-control-lg mb-5 mt-2 text-color"
                      >
                        <option value="get">GET</option>
                        <option value="post">POST</option>
                        <option value="put">PUT</option>
                        <option value="delete">DELETE</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-xl-4">
                    <div className="form-group ">
                      <label>EndPoint</label>
                      <div className="error-token">
                        {errorsEndpoint && <p>{errorsEndpoint}</p>}
                      </div>
                      <select
                        onChange={handleChange}
                        name="endpoint"
                        className="form-control form-control-lg mb-5 mt-2 text-color"
                      >
                        {suggestions.map((item, index) => {
                          return (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-4">
                    <div className="form-group">
                      <label>Get Parameters</label>
                      <input
                        type="text"
                        name="id"
                        className="form-control mb-5 letras"
                        placeholder="?parameter1=hola&parameter2=123"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-xl-4">
                    <div className="form-group">
                      <label>Public Token</label>
                      <div className="error-token">
                        {errors && <p>{errors}</p>}
                      </div>
                      <input
                        type="text"
                        name="publico"
                        className="form-control mb-5 letras"
                        placeholder="Enter public token"
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-xl-4">
                    <div className="form-group">
                      <label>Private Token</label>
                      <div className="error-token">
                        {errorPrivado && <p>{errorPrivado}</p>}
                      </div>
                      <input
                        type="text"
                        name="privado"
                        className="form-control mb-5 letras"
                        placeholder="Enter private token"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {(request.method === "post" || request.method === "put") && (
                  <div className="col--12">
                    <label>Payload</label>
                    <textarea
                      value={
                        request.method === "post" || request.method === "put"
                          ? request.codigo
                          : ""
                      }
                      name="codigo"
                      className="form-control mb-5 letras"
                      placeholder="Enter the payload here"
                      onChange={handleChange}
                    />
                  </div>
                )}

                <div className="col-md-12">
                  <label>Response</label>
                  {cargando ? (
                    <Spinner />
                  ) : (
                    <textarea
                      autoFocus={true}
                      readOnly
                      className="form-control x-large-textarea mb-5"
                      value={result}
                      name="respuesta"
                    />
                  )}
                </div>

                {result && (
                  <div>
                    <label>
                      This is the generated path:
                      <p>
                        {request.url}
                        {request.endpoint}
                        {request.id}
                      </p>
                    </label>
                  </div>
                )}

                {firma && (
                  <div>
                    <label>
                      This transaction generated the following signature:
                      <p>{firma}</p>
                    </label>
                  </div>
                )}

                <div className="col-md-12">
                  <div className="row">
                    {process.env.REACT_APP_INTRAVALIDATE !== validate && (
                      <div className="col-xxl-6 col-xl-6 col-md-6 col-sm-12 col-12 text-xxl-start text-xl-start text-lg-start text-md-start text-sm-center text-center">
                        <div className="m-0 p-0 justify-content-xxl-start justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center">
                          <Turnstile
                            className="d-sm-inline-block d-inline-block m-0 p-0"
                            options={responsiveTurnstile}
                            siteKey={process.env.REACT_APP_TOKEN_CAPTCHA}
                            onError={() => setStatus("error")}
                            onExpire={() => setStatus("expired")}
                            onSuccess={() => setStatus("success")}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-xxl-6 col-xl-6 col-md-6 col-sm-12 col-12 contact-btn text-xxl-end text-xl-end text-lg-end text-md-end text-sm-center text-center">
                      {status === "success" ||
                      process.env.REACT_APP_INTRAVALIDATE === validate ? (
                        <div className="d-flex flex-wrap justify-content-xxl-between justify-content-xl-between justify-content-lg-center justify-content-md-center justify-content-sm-center justify-content-center align-content-lg-center align-content-md-between align-content-sm-between">
                          <button
                            className="m-0 buttonOutline"
                            onClick={createSign}
                            // disabled={cargando}
                            type="submit"
                          >
                            Create Sign
                          </button>
                          <button
                            className="m-0"
                            onClick={handleSubmit}
                            disabled={cargando}
                            type="submit"
                          >
                            Send Request
                          </button>
                        </div>
                      ) : (
                        <div className="error-captcha"></div>
                      )}
                    </div>

                    {/* <Dialog
                    className="captchaError"
                    open={openModalFailedCaptcha}
                  >
                    <DialogContent>
                      <div className="captchaIcon">
                        <lord-icon
                          src="https://cdn.lordicon.com/inrunzby.json"
                          trigger="hover"
                          colors="primary:#ffc738,secondary:#4f1091"
                          scale="80"
                        ></lord-icon>
                      </div>
                      <div className="error">
                        <h2>Lo siento, no podemos procesar su solicitud.</h2>
                        <h4>Presione ACEPTAR para volver a intentar. </h4>
                      </div>
                      <DialogActions>
                        <Button onClick={() => window.location.reload(false)}>
                          Aceptar
                        </Button>
                      </DialogActions>
                    </DialogContent>
                  </Dialog> */}
                  </div>
                </div>
              </form>
              <footer className="text-color mb-5">
                &copy; {yearCopy} | Payku Spa
              </footer>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Formulario;